import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
      refetchOnWindowFocus: false,
      // Custom retry logic: don't retry on auth errors (401)
      // This prevents React Query from multiplying the infinite loop on iOS
      // when combined with the axios interceptor retry logic
      retry: (failureCount, error: any) => {
        // Don't retry on auth errors - let the interceptor handle redirect
        if (error?.status === 401) {
          return false;
        }
        // For other errors, retry once
        return failureCount < 1;
      },
    },
  },
});

